__webpack_require__.p = "https://qa.uk.knowledgesearchcore.thomsonreuters.com/";